(() => {
  let cleanup = () => {};

  function initialize() {
    cleanup();
    const nav = document.querySelector('.sonic-faq-nav');
    const slot = nav?.closest('.sonic-faq-nav-slot');
    const bar = nav?.closest('.sonic-faq-nav-bar');
    const links = nav ? [...nav.querySelectorAll('a')] : [];
    if (!links.length || !slot || !bar) return;
    const arrows = [...bar.querySelectorAll('[data-faq-direction]')];

    const header = document.querySelector('.page-header');
    const main = document.getElementById('root');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const events = new AbortController();
    let frame = null;
    let headerTransition = false;

    const headerOffset = () => {
      if (!header?.classList.contains('sticky-enabled')) return 0;
      return Math.max(0, header.getBoundingClientRect().bottom);
    };

    const revealLink = (link, immediate = false) => {
      if (!link || nav.scrollWidth <= nav.clientWidth) return;
      const bounds = nav.getBoundingClientRect();
      const item = link.getBoundingClientRect();
      const delta = item.left < bounds.left + 16
        ? item.left - bounds.left - 16
        : item.right > bounds.right - 16 ? item.right - bounds.right + 16 : 0;
      if (delta) nav.scrollBy({ left: delta, behavior: immediate || reducedMotion.matches ? 'auto' : 'smooth' });
    };

    const activate = (hash, reveal = false) => {
      links.forEach(link => {
        if (link.hash === hash) {
          link.setAttribute('aria-current', 'location');
          if (reveal) revealLink(link);
        } else link.removeAttribute('aria-current');
      });
    };

    const update = () => {
      frame = null;
      const offset = headerOffset();
      const height = bar.offsetHeight;
      slot.style.height = `${height}px`;
      bar.style.setProperty('--sonic-faq-header-offset', `${offset}px`);
      document.documentElement.style.setProperty('--sonic-faq-scroll-offset', `${offset + height + 16}px`);
      const sticky = slot.getBoundingClientRect().top <= offset && (!main || main.getBoundingClientRect().bottom > offset + height);
      const moved = sticky ? bar.parentElement !== document.body : bar.parentElement !== slot;
      const scrollLeft = nav.scrollLeft;
      // Escape the hero's clipped stacking context while preserving its layout slot.
      if (sticky && bar.parentElement !== document.body) document.body.appendChild(bar);
      if (!sticky && bar.parentElement !== slot) slot.appendChild(bar);
      bar.classList.toggle('is-sticky', sticky);
      if (moved) nav.scrollLeft = scrollLeft;
      const barStyle = getComputedStyle(bar);
      const navStyle = getComputedStyle(nav);
      const available = bar.clientWidth - parseFloat(barStyle.paddingLeft) - parseFloat(barStyle.paddingRight);
      const required = links.reduce((width, link) => width + link.offsetWidth, 0)
        + (links.length - 1) * (parseFloat(navStyle.columnGap) || 0)
        + parseFloat(navStyle.paddingLeft) + parseFloat(navStyle.paddingRight);
      const overflowing = required > available + 1;
      nav.classList.toggle('is-overflowing', overflowing);
      arrows.forEach(arrow => {
        arrow.hidden = !overflowing;
        arrow.disabled = Number(arrow.dataset.faqDirection) < 0
          ? nav.scrollLeft <= 1
          : nav.scrollLeft >= nav.scrollWidth - nav.clientWidth - 1;
      });
      if (moved) revealLink(nav.querySelector('[aria-current="location"]'), true);
      if (headerTransition) frame = requestAnimationFrame(update);
    };

    const scheduleUpdate = () => {
      if (frame === null) frame = requestAnimationFrame(update);
    };

    const activateHash = () => activate(links.some(link => link.hash === location.hash) ? location.hash : links[0].hash, true);
    links.forEach(link => {
      link.addEventListener('click', event => {
        activate(link.hash, true);
        const target = document.getElementById(decodeURIComponent(link.hash.slice(1)));
        if (!target || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        const top = target.getBoundingClientRect().top + window.scrollY - headerOffset() - bar.offsetHeight - 16;
        window.scrollTo({ top: Math.max(0, top), behavior: reducedMotion.matches ? 'auto' : 'smooth' });
        history.pushState(null, '', link.hash);
      }, { signal: events.signal });
    });
    arrows.forEach(arrow => arrow.addEventListener('click', () => {
      nav.scrollBy({ left: Number(arrow.dataset.faqDirection) * nav.clientWidth * .8, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
    }, { signal: events.signal }));
    nav.addEventListener('scroll', scheduleUpdate, { passive: true, signal: events.signal });
    nav.addEventListener('focusin', event => revealLink(event.target.closest('a')), { signal: events.signal });

    window.addEventListener('scroll', scheduleUpdate, { passive: true, signal: events.signal });
    window.addEventListener('resize', scheduleUpdate, { passive: true, signal: events.signal });
    window.addEventListener('hashchange', activateHash, { signal: events.signal });
    window.addEventListener('popstate', activateHash, { signal: events.signal });
    const observer = new MutationObserver(scheduleUpdate);
    if (header) observer.observe(header, { attributes: true, attributeFilter: ['class'] });
    const followHeader = event => {
      if (event.target !== header || event.propertyName !== 'transform') return;
      headerTransition = event.type === 'transitionrun';
      scheduleUpdate();
    };
    // Sample only while the header moves; no independent easing or permanent frame loop.
    ['transitionrun', 'transitionend', 'transitioncancel'].forEach(type => {
      header?.addEventListener(type, followHeader, { signal: events.signal });
    });
    const sizes = new ResizeObserver(scheduleUpdate);
    sizes.observe(bar);
    if (header) sizes.observe(header);

    cleanup = () => {
      events.abort();
      headerTransition = false;
      observer.disconnect();
      sizes.disconnect();
      if (frame !== null) cancelAnimationFrame(frame);
      slot.appendChild(bar);
      slot.style.removeProperty('height');
      bar.classList.remove('is-sticky');
      bar.style.removeProperty('--sonic-faq-header-offset');
      document.documentElement.style.removeProperty('--sonic-faq-scroll-offset');
    };
    activateHash();
    update();
  }

  initialize();
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('shopify:section:unload', event => {
    if (event.target.querySelector('.sonic-faq-nav-slot')) cleanup();
  });
})();
